import {FileFormURL} from "@/includes/file-form-url";
import {initIDMLViewer} from "@/includes/idml-parser";
import {IDML_LAYERS_FLOWS} from "@frontend/group/modules/idml-layers/event-broker";

export const ACTION_IMPORT_FROM_PRESELECTED_IDML = 'import-from-preselected-idml';

export const importPreselectedIDML = () => {
  const stored = localStorage.getItem(ACTION_IMPORT_FROM_PRESELECTED_IDML);

  if (!stored) {
    return;
  }

  const data = JSON.parse(stored);
  const files = (data.files || []).map(file => new FileFormURL(file.url, file.name, file.id));

  initIDMLViewer(files, {
    flow: IDML_LAYERS_FLOWS.CREATE_TEMPLATES,
    cleanupAction: ACTION_IMPORT_FROM_PRESELECTED_IDML,
  });
};
